import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container py-5" }
const _hoisted_2 = { class: "d-flex mobile-column" }
const _hoisted_3 = { class: "left pe-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "fw-9" }, "Kim Petras", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_6 = { class: "fw-bold" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Scan this QR code or cut and paste this link into safari to activate your Laminate in Augmented Reality ! ")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "mt-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/qr.png",
    alt: "QR Code",
    style: {"height":"180px"}
  })
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "mt-4",
  style: {"font-size":"18px"}
}, [
  /*#__PURE__*/_createTextVNode(" Grab your laminate and tap "),
  /*#__PURE__*/_createElementVNode("a", {
    style: {"text-decoration":"none"},
    href: "https://pckg.iimgs.co/193540575331"
  }, "this link "),
  /*#__PURE__*/_createTextVNode(" to start ")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "right" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card border-0" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/img/img.png",
      class: "img-fluid card-img-top",
      alt: ""
    })
  ])
], -1)

import {useRoute, useRouter} from "vue-router";
import {computed, ref, Ref} from "vue";
import axios, {AxiosError} from "axios";
import {apiHost} from "@/data/constants";
import {useForm} from "vee-validate";
import * as Yup from "yup";


export default /*#__PURE__*/_defineComponent({
  __name: 'PageWithCode',
  setup(__props) {

const codeInput1: Ref<HTMLInputElement | undefined> = ref()
const codeInput2: Ref<HTMLInputElement | undefined> = ref()
const codeInput3: Ref<HTMLInputElement | undefined> = ref()
const codeInput4: Ref<HTMLInputElement | undefined> = ref()

const inputs = {
  '1': codeInput1,
  '2': codeInput2,
  '3': codeInput3,
  '4': codeInput4,
} as { [k: string]: Ref<HTMLInputElement> }

const router = useRouter();
const route = useRoute();

const handlekeydown = (event: KeyboardEvent) => {
  if (!isNaN(parseInt(event.key))) {
    return
  } else if (event.key == "Meta" || event.metaKey || event.ctrlKey) {

  } else {
    event.preventDefault();
    event.stopPropagation();
  }
}

const handlekeyup = (event: KeyboardEvent, inputNumber: number) => {
  if (event.code === 'Backspace') {
    inputNumber -= 1;
  } else if (!isNaN(parseInt(event.key))) {
    inputNumber += 1;
  } else {
    return;
  }
  console.log({event})

  if (inputs[inputNumber.toString()]) {
    inputs[inputNumber.toString()].value.focus();
  }
}

const code1 = ref('')
const code2 = ref('')
const code3 = ref('')
const code4 = ref('')

const codeEntered = computed(() => {
  console.log((code1.value + code2.value + code3.value + code4.value))
  return (code1.value + code2.value + code3.value + code4.value).length === 4;
})
const submitButtonDisabled = ref(false)
const onFormSubmit = async () => {
  try {
    submitButtonDisabled.value = true;

    const code = code1.value + code2.value + code3.value + code4.value;

    const data = {
      email: route.query.email,
      code: code,
    }

    const response = await axios.post(`${apiHost}/kimp/check_email_verification_code`, data)
    // await router.push({name: "page2", query: data})
    await router.push({name: "page3", query: data})
  } catch (e) {
    const axiosError = e as AxiosError;
    if (axiosError.response?.status === 404) {
      alert('The code is invalid or was already used')
    } else {
      alert('Error')
    }
  } finally {
    submitButtonDisabled.value = false;
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("h5", _hoisted_6, " Upload Successful! Your unique passcode is: " + _toDisplayString(_unref(route).query.code), 1),
        _hoisted_7,
        _hoisted_8,
        _hoisted_9,
        _hoisted_10
      ]),
      _hoisted_11
    ])
  ]))
}
}

})